import React from 'react'
import style from "./Home2.module.css"

export const CarePass = () => {
  return (
    <div className={style.absulutebag}>
        <div className={style.h1}><h1>carepass</h1></div>
      <div className={style.carepass}>
          <div>
               <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_404,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/introducting-cult-pass/icp_cb.png" alt="" />

               <div className={style.simg}>
                  <h4>carepass</h4>
                  <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_107,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/brand-logo/cult-pass-elite-partial.png" alt="" />
               </div>
               <div className={style.text}>
                  <h3>Unlimited acess to</h3>
                  <ul> 
                  <li>At-center group classes</li>
                  <li>All ELITE & PRO gyms</li>
                  <li>At-home live workout</li>
                  </ul>
               </div>

               <div className={style.cbutton}>
                    <button>TRY FOR FREE</button>
                    <button>LEARN MORE</button>
               </div>
          </div>
          <div>
             <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_404,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/introducting-cult-pass/icp_cg.png" alt="" />
             <div className={style.simg}>
                  <h4>carepass</h4>
                  <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_78,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/brand-logo/cult-pass-pro-partial.png" alt="" />
               </div>
             <div className={style.text}>
                  <h3>Unlimited acess to</h3>
                 <ul>
                  <li>All PRO gyms</li>
                  <li>2 Sessions/m at ELITE gyms & groups classes</li>
                  <li>At-home live workout</li>
                  </ul>
               </div>
               <div className={style.cbutton}>
                    <button>TRY FOR FREE</button>
                    <button>LEARN MORE</button>
               </div>
          </div>
          <div>
            <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_404,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/introducting-cult-pass/icp_cl.png" alt="" />
            <div className={style.simg}>
                  <h4>carepass</h4>
                  <img src="https://cdn-images.cure.fit/www-curefit-com/image/upload/c_fill,w_112,q_auto:eco,dpr_2,f_auto,fl_progressive//image/test/brand-logo/cult-pass-home-partial-1.svg" alt="" />
               </div>
            <div className={style.text}>
                  <h3>Unlimited acess to</h3>
                 <ul> 
                  <li>At home workout</li>
                  <li>Celebrity Workouts</li>
                  <li>Goal-based Workouts and Meditation Sessions</li>
                  </ul>
               </div>
               <div className={style.cbutton}>
                    <button>TRY FOR FREE</button>
                    <button>LEARN MORE</button>
               </div>
          </div>
      </div>
    

     
    </div>
  )
}
